module.exports = __webpack_public_path__ + "img/internet.7df32553.png";